import { useCallback, useState } from 'react'

type AliasObject = {
  [key: string]: string
}

export const useAliasConstate = <T extends AliasObject>({ aliases = {} }) => {
  type Alias = {
    key: keyof T
    value: T[keyof T]
  }
  const [aliasList, setAliasList] = useState<T>(aliases as T)

  const addAlias = useCallback((alias: Alias) => {
    setAliasList((prev) => {
      if (prev[alias.key] !== undefined) {
        return prev
      }
      return { ...prev, [alias.key]: alias.value }
    })
  }, [])

  const removeAlias = useCallback((alias: Alias) => {
    setAliasList((prev) => {
      if (prev[alias.key] === undefined) {
        return prev
      }
      const newVal = { ...prev }
      delete newVal[alias.key]
      return newVal
    })
  }, [])

  const getAlias = (key: keyof T): T[keyof T] | undefined => aliasList[key]

  return { addAlias, getAlias, removeAlias }
}
